import _ from 'lodash';
import formatCurrency from 'format-currency';

class TransactionDetailsController {
  constructor($rootScope, $http, $state, $stateParams, toastr) {
    'ngInject';
    this.$state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.toastr = toastr;

    this.transaction = {};
    this.accounts = [];
    this.accountReferences = [];
    this.customers = [];
    this.customerReferences = [];
    this.loading = true;
    this.loadError = false;
    this.saving = false;
    this.formatCurrency = formatCurrency;
  }

  $onInit() {
    const self = this;
    const transactionId = this.transactionId || this.$stateParams.transactionId;

    if (!transactionId) {
      this.loading = false;
      this.loadError = true;
      if (!this.isModal) {
        this.$state.go('notfound');
      }
      return;
    }

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/accountrefs?type=Expense', {withCredentials: true}).then(function (success) {
      (success.data || []).forEach(function (x) {
        self.accountReferences.push(x);
      });
    });

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/accountrefs?type=Other%20Current%20Liability', {withCredentials: true}).then(function (success) {
      (success.data || []).forEach(function (x) {
        self.accountReferences.push(x);
      });
    });

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/accounts?type=Expense', {withCredentials: true}).then(function (success) {
      (success.data || []).forEach(function (x) {
        self.accounts.push(x);
      });
    });

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/accounts?type=Other%20Current%20Liability', {withCredentials: true}).then(function (success) {
      (success.data || []).forEach(function (x) {
        self.accounts.push(x);
      });
    });

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/allcustomers', {withCredentials: true}).then(function (success) {
      self.customers = success.data || [];
    });

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/allcustomerrefs', {withCredentials: true}).then(function (success) {
      self.customerReferences = success.data || [];
    });

    this.$http.get(this.$rootScope.apiHost + '/api/integrations/qb/transactions/' + transactionId, {withCredentials: true}).then(function (success) {
      self.transaction = success.data || {};
      if (!self.transaction.line) {
        self.transaction.line = [];
      }
      self.loading = false;
    }, function () {
      self.loading = false;
      self.loadError = true;
      if (!self.isModal) {
        self.$state.go('notfound');
      }
    });
  }

  closeModal() {
    if (this.onClose) {
      this.onClose();
    }
  }

  addLine() {
    if (!this.transaction.line) {
      this.transaction.line = [];
    }
    this.transaction.line.push({
      detailType: 'ACCOUNT_BASED_EXPENSE_LINE_DETAIL',
      accountBasedExpenseLineDetail: {}
    });
  }

  saveTransaction(override) {
    let self = this;
    if (this.saving) {
      return;
    }
    if (!override && this.amountsMismatch()) {
      this.toastr.warning('Line totals must match the transaction amount, or use Override & Save.', 'Cannot Save');
      return;
    }

    this.saving = true;
    this.$http.post(this.$rootScope.apiHost + '/api/integrations/qb/transactions/' + this.transaction.id, this.transaction, {withCredentials: true}).then(function (success) {
      self.transaction = success.data || self.transaction;
      if (!self.transaction.line) {
        self.transaction.line = [];
      }
      self.toastr.success('Transaction saved to QuickBooks.', 'Success');
    }, function (failure) {
      const message = (failure.data && (failure.data.message || failure.data.error))
        || 'Could not save transaction to QuickBooks.';
      self.toastr.error(message, 'ERROR');
    }).finally(function () {
      self.saving = false;
    });
  }

  removeLine(line) {
    _.remove(this.transaction.line, function (n) {
      return n === line || (n.id != null && line.id != null && n.id == line.id);
    });

    let l = 1;
    this.transaction.line.forEach(function (entry) {
      entry.id = '' + l;
      l++;
    });
  }

  getLineTotalValue() {
    let sum = 0;
    if (this.transaction && this.transaction.line) {
      this.transaction.line.forEach(function (line) {
        sum = sum + (Number(line.amount) || 0);
      });
    }
    return Math.round(sum * 100) / 100;
  }

  getLineTotals() {
    return this.formatDollars(this.getLineTotalValue());
  }

  formatDollars(value) {
    if (typeof value !== 'number' || isNaN(value)) {
      const parsed = Number(value);
      if (isNaN(parsed)) {
        return formatCurrency(0);
      }
      return formatCurrency(parsed);
    }
    return formatCurrency(value);
  }

  getAccountName(s) {
    if (!s) {
      return undefined;
    }
    if (s.acctNum) {
      return s.acctNum + ' - ' + s.fullyQualifiedName;
    }
    return s.fullyQualifiedName;
  }

  getAccountNameById(id) {
    if (id == null) {
      return undefined;
    }
    let result = _.find(this.accounts, {id: id + ''}) || _.find(this.accounts, {id: id});
    if (result) {
      return this.getAccountName(result);
    }
  }

  getCustomerNameById(id) {
    if (id == null) {
      return undefined;
    }
    let result = _.find(this.customers, {id: id + ''}) || _.find(this.customers, {id: id});
    if (result) {
      return result.fullyQualifiedName || result.displayName || result.name;
    }
  }

  amountsMismatch() {
    const lineTotal = this.getLineTotalValue();
    const txnTotal = Math.round((Number(this.transaction.totalAmt) || 0) * 100) / 100;
    return lineTotal !== txnTotal;
  }
}

export default TransactionDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/transaction-details/transaction-details.controller.js